import logo from './logo.svg';
import './App.css';
import Usercard from './Components/userCard.js';

function App() {
  return (
    <div className='App-header'>
      <Usercard />
    </div>

  );
}

export default App;
